import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from '@apollo/react-hoc';
import get from 'lodash/get';

import { injectIntl } from 'react-intl';
import { routerShape } from 'react-router';
import { SimpleGraphQLComponent } from '../../utils/apollo';
import CollegeEventsFilterComponent from './views';
import CreateFilterMutation from './graphql/createFilterMutation';
import emptyFilter from './emptyFilter';
import messages from './messages';
import Toast from '../../components/Toast';

class CollegeEventsCreateFilter extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    viewer: PropTypes.object,
    createFilter: PropTypes.func.isRequired,
    router: routerShape,
    onFilterSaved: PropTypes.func,
    onCancel: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      saveSuccess: false,
      saveError: null,
    };
  }

  onSave = (filter) => {
    const { createFilter } = this.props;
    this.setState({ saving: true, saveSuccess: false, saveError: null });
    const variables = {
      input: {
        collegeEventFilter: filter,
      },
    };
    createFilter({ variables }).then(this.onSaveSuccess, this.onSaveError).catch(this.onSaveError);
  };

  onSaveSuccess = (result) => {
    this.setState({ saving: false, saveSuccess: true, saveError: null });
    if (this.props.onFilterSaved) {
      this.props.onFilterSaved(result);
      return;
    }
    this.goBack();
  };

  goBack = () => {
    this.props.router.push('/college-events/view-filters');
  };

  onSaveError = (err) => {
    const error = get(err, 'graphQLErrors[0].message') || get(err, 'message') || '';
    const isUniqueNameError = error.includes('filter name should be unique');
    const isIncorrectPostalCode = error.includes(messages.incorrectPostalCode.defaultMessage);
    let saveError = isUniqueNameError ? messages.errorUniqueName : messages.saveError;

    if (!isUniqueNameError) {
      saveError = isIncorrectPostalCode ? messages.incorrectPostalCode : messages.saveError;
    }

    this.setState({ saving: false, saveSuccess: false, saveError });
  };

  onDeactivate = () => {
    this.setState({ saveSuccess: false });
  }

  render() {
    const { intl } = this.props;
    const { saving, saveSuccess, saveError } = this.state;
    return (
      <React.Fragment>
        <Toast
          active={saveSuccess}
          onDeactivate={this.onDeactivate}
          title={intl.formatMessage(messages.successTitle)}
          description={intl.formatMessage(messages.successDescription)}
        />
        <CollegeEventsFilterComponent
          filter={emptyFilter}
          saving={saving}
          saveError={saveError}
          onSave={this.onSave}
          onCancel={this.props.onCancel || this.goBack}
        />
      </React.Fragment>
    );
  }
}

const createFilter = graphql(CreateFilterMutation, {
  name: 'createFilter',
  options: {
    refetchQueries: ['collegeEventsFilters', 'collegeEventFilters'],
    awaitRefetchQueries: true,
  },
});

export const CollegeEventsCreateFilterComponent = injectIntl(CollegeEventsCreateFilter);
export default SimpleGraphQLComponent(createFilter)(CollegeEventsCreateFilterComponent);
